import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCsv = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 0.5H11.793L15.5 4.207V14.5C15.5 15.052 15.052 15.5 14.5 15.5H5.5C4.948 15.5 4.5 15.052 4.5 14.5V1.5C4.5 0.948 4.948 0.5 5.5 0.5Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.788 0.5L15.5 4.223V4.5H11.5V0.5H11.788Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6,
			width: 14,
			height: 8,
			rx: 1.5,
			fill: "#16B15F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.991 7.899H9.906L10.796 11.012L11.695 7.899H12.585L11.186 12H10.376L8.991 7.899Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.925 11.407C7.127 11.407 7.291 11.385 7.417 11.341C7.657 11.255 7.776 11.097 7.776 10.865C7.776 10.729 7.717 10.625 7.598 10.551C7.48 10.478 7.293 10.414 7.039 10.359L6.605 10.261C6.178 10.165 5.883 10.06 5.72 9.947C5.444 9.758 5.306 9.462 5.306 9.059C5.306 8.692 5.439 8.387 5.706 8.144C5.973 7.901 6.366 7.779 6.883 7.779C7.315 7.779 7.684 7.894 7.988 8.124C8.294 8.352 8.454 8.684 8.469 9.12H7.646C7.631 8.874 7.523 8.698 7.323 8.595C7.189 8.526 7.023 8.492 6.825 8.492C6.604 8.492 6.428 8.536 6.296 8.625C6.164 8.714 6.099 8.838 6.099 8.998C6.099 9.144 6.164 9.254 6.293 9.326C6.377 9.374 6.555 9.431 6.828 9.496L7.534 9.666C7.844 9.74 8.078 9.839 8.235 9.963C8.48 10.156 8.603 10.436 8.603 10.801C8.603 11.176 8.459 11.487 8.171 11.736C7.886 11.982 7.481 12.106 6.958 12.106C6.424 12.106 6.004 11.984 5.698 11.741C5.392 11.496 5.239 11.161 5.239 10.734H6.057C6.083 10.921 6.134 11.062 6.21 11.154C6.349 11.323 6.587 11.407 6.925 11.407Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.155 11.694C3.849 11.974 3.458 12.114 2.981 12.114C2.391 12.114 1.928 11.925 1.59 11.547C1.252 11.166 1.084 10.645 1.084 9.983C1.084 9.267 1.276 8.715 1.66 8.327C1.993 7.99 2.418 7.821 2.934 7.821C3.624 7.821 4.128 8.047 4.447 8.5C4.624 8.754 4.718 9.009 4.731 9.265H3.874C3.819 9.068 3.747 8.92 3.66 8.82C3.504 8.642 3.273 8.553 2.967 8.553C2.656 8.553 2.41 8.679 2.23 8.931C2.05 9.182 1.96 9.537 1.96 9.997C1.96 10.457 2.055 10.802 2.244 11.032C2.435 11.26 2.677 11.374 2.97 11.374C3.271 11.374 3.5 11.276 3.657 11.079C3.744 10.973 3.817 10.815 3.874 10.603H4.723C4.649 11.05 4.459 11.414 4.155 11.694Z",
			fill: "white"
		})
	]
});
export default SvgCsv;
